import { Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import { TaskServiceInterface } from './definitions/task-service-interface';
import { Observable } from 'rxjs';
import { ErrorsInterface } from '../errors/errors-interface';
import { DocumentNode } from 'graphql';
import { FetchResult } from '@apollo/client/core';

interface MarkAsNotExecutedResponse {
  task: {
    markAsNotExecuted: {
      output: TaskServiceInterface;
      errors: ErrorsInterface;
    };
  };
}

@Injectable()
export class TaskMarkAsNotExecutedService {
  constructor(private apollo: Apollo) {}

  markAsNotExecuted(
    taskId,
    reason,
    mutation: DocumentNode
  ): Observable<FetchResult<MarkAsNotExecutedResponse>> {
    return this.apollo.mutate<MarkAsNotExecutedResponse>({
      mutation: mutation,
      variables: {
        id: taskId,
        reason: reason,
      },
    });
  }
}
